import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { showToast } from './toastSlice'
import makeRequest from 'src/services/api'
import handleGeneralError from '../helpers/errorHandler'
import { fetchApiDetailsUrl } from 'src/services/urls'
import { getUniqueListBy } from 'src/lib/utils'

const initialState = {
  loading: false,
  data: { hasMore: false, page: 1, totalDocs: 0, nextPage: 0 },
  docs: [],
  error: '',
  activePage: 0,
  pageSize: 10,
  total: 0,
  limit: 500,
  totalPages: 0,
  serviceFilter: '',
  durationFilter: '',
  serviceValues: [],
  queryFilters: {},
}

export const fetchApiDetails = createAsyncThunk(
  'apiDetails/fetchApiDetails',
  async (params, { dispatch, getState }) => {
    try {
      let query = '?'
      for (let key in params) {
        if (params[key] === '') continue
        if (key === 'date') {
          let selectedDate = new Date(params[key])
          let m = selectedDate.getMonth() + 1
          let d = selectedDate.getDate()
          if (m < 10) m = `0${m}`
          if (d < 10) d = `0${d}`

          query += `${key}=${selectedDate.getFullYear()}-${m}-${d}&`
        } else {
          query += `${key}=${params[key]}&`
        }
      }

      query = query.slice(0, -1)
      const url = fetchApiDetailsUrl() + query
      const response = await makeRequest(url, 'GET')
      if (
        response.data.statusCode === 404 &&
        response.data.displayMessage === 'Logger File Not Found'
      ) {
        return { data: { result: [] } }
      }

      return { data: response.data.data }
    } catch (e) {
      if (
        e.response.data.statusCode === 404 &&
        e.response.data.displayMessage === 'Logger File Not Found'
      ) {
        return {
          data: { result: [], services: [], activePage: 0, total: 0, limit: 500, totalPages: 0 },
        }
      }
      return { error: e?.response?.data?.error?.message }
    }
  },
)

const analyticsSlice = createSlice({
  name: 'analyticsSlice',
  initialState,
  reducers: {
    setActivePage: (state, action) => {
      state.activePage = action.payload
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setServiceFilter: (state, action) => {
      state.serviceFilter = action.payload
    },
    setDurationFilter: (state, action) => {
      state.durationFilter = action.payload
    },
    setQueryFilters: (state, action) => {
      state.queryFilters = { ...state.queryFilters, ...action.payload }
    },
    setResetRecords: (state, action) => {
      state.docs = []
      state.data.result = []
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchApiDetails.pending, (state) => {
      state.loading = true
    })
    builder.addCase(fetchApiDetails.fulfilled, (state, action) => {
      state.error = action.payload.error
      if (!action.payload.error) {
        state.data = action.payload.data
        const oldData = action.payload.filtered ? [] : state.docs

        const totalData = [...oldData, ...action.payload.data.result]
        const uniqueData = getUniqueListBy(totalData, '_id')
        state.docs = uniqueData
        state.total = action.payload.data.total
        state.totalPages = action.payload.data.totalPages
        let filterServices = []
        let existingFilterServices = [
          ...state.serviceValues.map((v) => v.value),
          ...action.payload.data.services,
        ]
        for (let i = 0; i < existingFilterServices.length; i++)
          filterServices[existingFilterServices[i]] = true

        state.serviceValues = Object.keys(filterServices)
      }
      state.loading = false
    })
    builder.addCase(fetchApiDetails.rejected, (state, action) => {
      state.loading = false
      state.data = {}
      state.docs = []
      state.error = action.error.message
      state.activePage = 0
      state.total = 0
      state.limit = 500
      state.totalPages = 0
    })
  },
})

export const {
  setLoading,
  setActivePage,
  setPageSize,
  setServiceFilter,
  setDurationFilter,
  setQueryFilters,
  setResetRecords,
} = analyticsSlice.actions
export default analyticsSlice.reducer
